// extracted by mini-css-extract-plugin
export var body = "PlaceMedal-module--body--23049";
export var bronze = "PlaceMedal-module--bronze--eda0c";
export var gold = "PlaceMedal-module--gold--04116";
export var medal = "PlaceMedal-module--medal--057b9";
export var medalGleam = "PlaceMedal-module--medal-gleam--800a8";
export var ribbon = "PlaceMedal-module--ribbon--ba4c7";
export var silver = "PlaceMedal-module--silver--c9e32";